import { useEffect } from 'react';

export default function useDocumentTitle(title) {
  let defaultTitle = "Arctic Research Database";
  if (title === undefined) {
    title = defaultTitle;
  }
  
  useEffect(() => {
    document.title = `${title} | Arctic Research Database`;
  }, [title]);
}